// extracted by mini-css-extract-plugin
export default {"recommendedArticlesContainer":"RecommendationsTwoByTwoLayout_recommendedArticlesContainer__7r4fw","sectionSpacing":"RecommendationsTwoByTwoLayout_sectionSpacing__QggsF"};